import React from "react";
import "./NAT.scss";

const NetworkandTraining = () => {
  return (
    <div className="NAT">
      <h2> Networks & Training</h2>
      <p>
        <b>Petroen  Networks</b> is a leader in systems and network
        infrastructure services. Petroen  Networks’ engineers have extensive
        professional experience and industry credentials. Our leadership in
        network technology enables Petroen  to become a strategic partner of our
        clients IT initiatives.
      </p>
      <p>
        Our team specializes in providing IT and business solutions for the
        small and medium organizations. Our mission is simple: to provide a
        comprehensive networking solution for your business.
      </p>
      <p>
        <b>Petroen  Networks</b> online Training & Certification offers the
        following major benefits to its students:
      </p>
      <ul>
        <li>
          <b>Eliminate travel time and expense</b> by training business
          professionals in multiple locations in a convenient, interactive
          online computer training session at your office or at their home.
        </li>
        <li>
          <b>Save money</b> by offering hands-on training sessions, customized
          or standard curriculum, for small and large groups no matter the
          location of your participants.
        </li>
        <li>
          <b>Meet just-in-time training requirements</b> by scheduling live,
          online training on specific, meaningful topics for a department or
          project team.
        </li>
      </ul>
    </div>
  );
};
export default NetworkandTraining;
